import CategoryNameContainer from '../../containers/CategoryName';

const CategoryName = () => {

  return <CategoryNameContainer />
}

export default CategoryName;